import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { BreadCrumb } from 'primereact/breadcrumb';
import { PrimeIcons } from 'primereact/api';
import { Tag } from 'primereact/tag';
import { Chip } from 'primereact/chip';
import { ProgressSpinner } from 'primereact/progressspinner';


import Config from '../config';
import Utils from '../Utils';
import { Dialog } from 'primereact/dialog';

const ProductsDetail = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [logs, setLogs] = useState([]);
    const [loadingLogs, setLoadingLogs] = useState(true);
    const [loadingSync, setLoadingSync] = useState(false);

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (!loading) {
            loadLogs();
        }
    }, [loading]);

    const load = () => {
        setLoading(true);

        Axios.get(Config.API_BASE_URL+"/api/products/"+id)
            .then(result => result.data)
            .then(result => {
                setData(result.data);
                setLoading(false);
            });
    }

    const loadLogs = () => {
        setLoadingLogs(true);

        Axios.get(Config.API_BASE_URL+"/api/logs/products/"+data.sku)
            .then(result => result.data)
            .then(result => {
                setLogs(result.data);
                setLoadingLogs(false);
            });
    }

    const sync = variant => {
        setLoadingSync(true);

        Axios.put(Config.API_BASE_URL+"/api/products/"+id, {
            variant: {
                aic: variant.sku,
                inventory_item_id: variant.inventory_item_id,
                variant_id: variant.id,
                product_id: id
            }
        })
        .then(result => {
            setLoadingSync(false);
            load();
        });
    };

    const rowDatetime = row => moment(row.time).format('D MMM HH:mm:ss');
    const rowAIC = row => row.aic;
    const rowType = row => _.defaultTo(row.context.type, row.message);
    const rowData = row => {
        if (row.message === 'Update price') {
            return <>
                Costo: {row.cost}<br />
                Prezzo: {row.price}<br />
                Prezzo di listino: {row.suggested_price}<br />
            </>;
        }
        else if (row.message === 'Update quantity') {
            return row.quantity;
        }
        else if (row.context.type === 'tags') {
            return row.context.tags;
        }
        else {
          return '';
        }
    };
    const rowSource = row => row.message === 'Update price' ? row.wholesaler : '';

    return (
        <div className="grid">
            <div className="col-12">
                {loading
                    ? <ProgressSpinner />
                    : <div className="card">
                        <ul className="list-none p-0 m-0 flex align-items-center font-medium mb-3">
                            <li>
                                <Link to="/products">
                                    <button className="p-link text-500 no-underline line-height-3 cursor-pointer">Prodotti</button>
                                </Link>
                            </li>
                            <li className="px-2">
                                <i className="pi pi-angle-right text-500 line-height-3"></i>
                            </li>
                            <li>
                                <span className="text-900 line-height-3">{id}</span>
                            </li>
                        </ul>

                        <div className="surface-section">
                            <div className="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
                                <div>
                                    <div className="font-medium text-3xl text-900">{data.title}</div>
                                    <div className="flex align-items-center text-700 flex-wrap">
                                        <div className="mr-5 flex align-items-center mt-3">
                                            <i className="pi pi-shopping-bag mr-2"></i>
                                            <span>{data.vendor}</span>
                                        </div>
                                        <div className="flex align-items-center mt-3">
                                            <i className="pi pi-clock mr-2"></i>
                                            <span>{moment(data.updated_at).format('D MMMM YYYY - HH:mm')}</span>
                                        </div>
                                        <div className="ml-5 mt-3">
                                            {data.tags?.split(',').map(tag => (
                                                <Chip label={tag} className="mr-1 mb-1" />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 lg:mt-0">
                                    <Button
                                        loading={loadingSync}
                                        icon={PrimeIcons.SYNC}
                                        label="Sincronizza"
                                        onClick={() => sync(data)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="surface-section mt-5">
                            <ul className="list-none p-0 m-0">
                                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                    <div className="text-500 w-6 md:w-3 font-medium">AIC</div>
                                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.sku}</div>
                                </li>
                                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                    <div className="text-500 w-6 md:w-3 font-medium">Disponibilità</div>
                                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                                        {data.inventor_quantity}
                                    </div>
                                </li>
                                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                    <div className="text-500 w-6 md:w-3 font-medium">Prezzo</div>
                                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{Utils.formatCurrency(data.price)}</div>
                                </li>
                                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                    <div className="text-500 w-6 md:w-3 font-medium">Prezzo di listino</div>
                                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{Utils.formatCurrency(data.compare_at_price)}</div>
                                </li>
                                <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
                                    <div className="text-500 w-6 md:w-3 font-medium">Ultimo aggiornamento</div>
                                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1 line-height-3">
                                        {moment(logs[0]?.time).format('D MMMM YYYY - HH:mm')}
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <h2>Storico aggiornamenti</h2>
                        <DataTable
                            className="p-datatable-gridlines"
                            responsiveLayout="scroll"
                            lazy
                            dataKey="id"
                            value={logs}
                            showGridlines
                            loading={loadingLogs}
                            emptyMessage="Nessun log trovato."
                        >
                            <Column field="id" body={rowDatetime} header="Data e ora" />
                            <Column key="aic" body={rowAIC} header="AIC" field="aic" />
                            <Column field="type" body={rowType} header="Tipo" />
                            <Column body={rowData} header="Dati" />
                            <Column field="source" body={rowSource} header="Origine" />
                        </DataTable>
                    </div>
                }
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ProductsDetail, comparisonFn);
